import { initKeepAwake } from './keep-awake.ts';

initKeepAwake();
